import React, { useState, useEffect } from "react";
// import call from "assets/images/call-phone.png";
import zalo from "assets/images/zalo.png";
// import chat from "assets/images/chat.png";

const styles = {
  container: {
    position: "fixed",
    bottom: "0px",
    left: "10px",
    backgroundColor: "white",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    borderRadius: "12px",
    padding: "10px",
    zIndex: 9999,
    fontFamily: "sans-serif",
    maxHeight: "160px",
    width: "160px",
    animation: "floatBox 3s ease-in-out infinite",
  },
  itemBase: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "#000",
    fontSize: "13px",
    transition: "all 0.3s ease",
    borderRadius: "8px",
    padding: "8px",
    position: "relative",
    zIndex: 2,
  },
  itemHover: {
    transform: "scale(1.05)",
    filter: "brightness(1.2)",
    cursor: "pointer",
    backgroundColor: "rgb(82, 82, 82)",
    color: "#fff",
  },
  rippleWrapper: {
    position: "relative",
    width: "32px",
    height: "32px",
    marginRight: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    width: "22px",
    height: "22px",
    zIndex: 2,
  },
  text: {
    animation: "pulseText 2s infinite",
    fontWeight: 500,
  },
};

const injectWaveformCSS = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    @keyframes pulse {
      0% { transform: scale(1); opacity: 1; }
      50% { transform: scale(1.2); opacity: 0.85; }
      100% { transform: scale(1); opacity: 1; }
    }

    @keyframes pulseText {
      0%, 100% { transform: scale(1); opacity: 1; }
      50% { transform: scale(1.1); opacity: 0.9; }
    }

    @keyframes ripplePulse {
      0% {
        transform: scale(1);
        opacity: 0.5;
      }
      50% {
        transform: scale(1.8);
        opacity: 0.2;
      }
      100% {
        transform: scale(2.5);
        opacity: 0;
      }
    }

    .ripple-icon::before {
      content: "";
      position: absolute;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: rgba(30, 144, 255, 0.3);
      animation: ripplePulse 2.5s infinite ease-out;
      z-index: 1;
    }
  `;
  document.head.appendChild(style);
};

function FloatingContactBox() {
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    injectWaveformCSS();
  }, []);

  const handleHover = (key) => setHovered(key);
  const handleLeave = () => setHovered(null);

  const getItemStyle = (key) => ({
    ...styles.itemBase,
    ...(hovered === key ? styles.itemHover : {}),
  });

  const renderItem = (key, href, icon, label) => (
    <a
      key={key}
      href={href}
      target={href.startsWith("http") ? "_blank" : "_self"}
      rel="noopener noreferrer"
      style={getItemStyle(key)}
      onMouseEnter={() => handleHover(key)}
      onMouseLeave={handleLeave}
    >
      <div className="ripple-icon" style={styles.rippleWrapper}>
        <img src={icon} alt={label} style={styles.icon} />
      </div>
      <span style={styles.text}>{label}</span>
    </a>
  );

  return (
    <div style={styles.container}>
      {/* {renderItem("call", "tel:0903132585", call, "0903132585")}
      {renderItem("chat", "https://m.me/ZumiUniform", chat, "CHAT FB")} */}
      {renderItem("zalo", "http://zalo.me/0932087770", zalo, "CHAT ZALO")}
    </div>
  );
}

export default FloatingContactBox;
